import React from 'react';
import { Card, CardContent } from '@lb-service/ui';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import CourseListItem from './CourseListItem';
import SectionIntro from '../../../molecules/SectionIntro';

const CourseList = () => {
  const { t } = useTranslation('common');
  return (
    <Card>
      <CardContent>
        <div id="courses-index-course-list">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 mt-24 mb-24">
            <SectionIntro title={t('service.courses.index.courseList.title')} />
            <div className="course-list grid grid-cols-12 gap-4">
              <div className="col-span-12 lg:col-span-4 md:col-span-6 mb-8">
                <CourseListItem
                  url="/courses/daily-conversation"
                  imageUrl="/images/background_daily_conversation.jpg"
                  title={t(
                    'service.courses.index.courseList.dailyConversation.title',
                  )}
                  intro={t(
                    'service.courses.index.courseList.dailyConversation.intro',
                  )}
                />
              </div>
              <div className="col-span-12 lg:col-span-4 md:col-span-6 mb-8">
                <CourseListItem
                  url="/courses/free-conversation"
                  imageUrl="/images/background_free_conversation_test.jpg"
                  title={t(
                    'service.courses.index.courseList.freeConversation.title',
                  )}
                  intro={t(
                    'service.courses.index.courseList.freeConversation.intro',
                  )}
                />
              </div>
              <div className="col-span-12 lg:col-span-4 md:col-span-6 mb-8">
                <CourseListItem
                  url="/courses/pronunciation"
                  imageUrl="/images/background_pronunciation.jpg"
                  title={t(
                    'service.courses.index.courseList.pronunciation.title',
                  )}
                  intro={t(
                    'service.courses.index.courseList.pronunciation.intro',
                  )}
                />
              </div>
              <div className="col-span-12 lg:col-span-4 md:col-span-6 mb-8">
                <CourseListItem
                  url="/courses/useful-expressions"
                  imageUrl="/images/background_useful_expressions.jpg"
                  title={t(
                    'service.courses.index.courseList.usefulExpressions.title',
                  )}
                  intro={t(
                    'service.courses.index.courseList.usefulExpressions.intro',
                  )}
                />
              </div>
              <div className="col-span-12 lg:col-span-4 md:col-span-6 mb-8">
                <CourseListItem
                  url="/courses/travel-english"
                  imageUrl="/images/background_travel.jpg"
                  title={t(
                    'service.courses.index.courseList.travelEnglish.title',
                  )}
                  intro={t(
                    'service.courses.index.courseList.travelEnglish.intro',
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default CourseList;
